import { l } from '@manychat/manyui'

import { IMenuChannelState } from 'apps/menu/menuInterfaces'
import { ChannelType } from 'common/core/constants/ChannelType'

export type IMenuPartialRootState = Pick<RootState, 'menu'>

export const MAX_MENUS_COUNT = 20

export const MENU_ROUTE = 'automation/menu'

export const DEFAULT_MENU_VALUE = 'DEFAULT_MENU'
export const getDefaultMenuLabel = l.makeTranslate('Default Menu')

export const getInitialMainMenuChannelState = (
  channel: ChannelType,
): Partial<IMenuChannelState> => ({
  channel,
  name: null,
  enabled: null,
  version: null,
  isMain: false,
  isFetched: false,
  isBusy: false,
  isAutoSaving: false,
  selectedId: null,
  showErrors: false,
  lastSaved: null,
  lastChanged: null,
  flowNs: null,
  draft: {
    byId: {},
    nested: [],
  },
  published: {
    byId: {},
    nested: [],
  },
})
